import { createFileRoute } from "@tanstack/react-router";
import Manufacturing from "@/pages/industries/Manufacturing";

export const Route = createFileRoute("/industries/manufacturing")({ component: Manufacturing });